import { constants as config } from '@config';
import Store from '@store';
import { getAssetsData } from 'src/store/selectors/assets.selector';

const humps = require('../../../../utils/humps');

module.exports = ElementSetter;

function ElementSetter () {
  this.handledAttributes = [
    'smart_asset',
    'position',
    'rotation',
    'opacity',
    'size',
    'locked',
    'link'
  ];
}

ElementSetter.prototype = _.extend({}, Backbone.Events);
ElementSetter.prototype.initialize = function () {
  this.editor = INKIVE.Tool.getInstance().editor;
  this.canvas = this.editor.canvas;

  _.bindAll(this, 'set');
};

ElementSetter.prototype.set = function (element, data) {
  _.each(data, function (value, attributeName) {
    if (_.contains(this.handledAttributes, attributeName)) {
      const updateMethod = humps.camelize('update_' + attributeName);
      this[updateMethod](element, data);
    }
  }, this);

  data.skipHistory = data.is_initial_load || data.skipHistory;

  this.trigger('', element.getAttribute('id'), data);
};

ElementSetter.prototype.selectElement = function (element) {
  const currentSelection = _.compact(_.toArray(this.canvas.getSelectedElems()));

  if (currentSelection.length !== 1 || currentSelection[0] !== element) {
    this.canvas.clearSelection();
    this.canvas.selectOnly([element]);
  }
};

ElementSetter.prototype.updateSmartAsset = function (element, data) {
  const {
    userInput: userInputsAttr,
    definedAsset: definedAssetAttr,
    definedContentType: definedContentTypeAttr
  } = config.smartAssets.attributes;

  const state = Store.getState();
  const definedAssetValue = element.getAttribute(definedAssetAttr);
  let definedAssets = definedAssetValue
    ? definedAssetValue
      .toString()
      .trim(',')
      .split(',')
      .map(getAssetsData(state, 'definedAssets'))
      .filter(a => !!a)
    : [];

  let userInputs = element.getAttribute(userInputsAttr);
  userInputs = userInputs ? userInputs.trim(',') : userInputs;
  const newAsset = data.smart_asset && (data.just_added || getAssetsData(state, 'definedAssets')(data.smart_asset));

  if (newAsset) {
    definedAssets = addNewAsset(definedAssets, newAsset);
  } else {
    definedAssets = cleanDefinedAssets(definedAssets, data);
  }

  userInputs
    ? element.setAttribute(userInputsAttr, userInputs)
    : element.removeAttribute(userInputsAttr);

  let definedContentType = null;
  const definedAssetIds = definedAssets.map(asset => {
    if (!config.smartAssets.descriptionalTypes.includes(asset.type)) {
      definedContentType = config.smartAssets.typeToProperty[asset.type];
    }

    return asset.id;
  });

  definedAssetIds
    ? element.setAttribute(definedAssetAttr, definedAssetIds.join(','))
    : element.removeAttribute(definedAssetAttr);

  definedContentType
    ? element.setAttribute(definedContentTypeAttr, definedContentType)
    : element.removeAttribute(definedContentTypeAttr);

  this.trigger('smart_asset', element.getAttribute('id'), { smart_asset: data.smart_asset });
  INKIVE.EditorFacade.trigger('smart_asset.updated', {});
  INKIVE.ImagesFactory.addBBoxValues(element);

  function addNewAsset (assets, newAsset) {
    const newAssetType = (config.smartAssets.typeToProperty[newAsset.type] || newAsset.type).toLowerCase();

    return assets
      .filter(({ type }) => {
        return newAssetType !== config.smartAssets.typeToProperty[type].toLowerCase() && newAssetType !== type.toLowerCase();
      })
      .concat(newAsset);
  }

  function cleanDefinedAssets (definedAssets, data) {
    const dataType = data.skipDefinedAsset || Object.values(config.smartAssets.typeToProperty).find(i => data[i]);

    return definedAssets
      .filter(({ type }) => {
        return dataType
          ? dataType !== config.smartAssets.typeToProperty[type]
          : config.smartAssets.descriptionalTypes.includes(type);
      });
  }
};

ElementSetter.prototype.updatePosition = function (element, data) {
  const p = data.position;
  const bb = element.getBBox();
  const editorFacade = require('../../../editor/editor');
  const zoom = editorFacade.handle('zoom', 'get');

  this.selectElement(element);
  this.canvas.moveSelectedElements((p.x - bb.x) * zoom, (p.y - bb.y) * zoom);
  this.trigger('position', element.getAttribute('id'), { position: p });
};

ElementSetter.prototype.updateRotation = function (element, data) {
  this.selectElement(element);
  this.canvas.setRotationAngle(data.rotation);
  this.trigger('rotation', element.getAttribute('id'), {
    rotation: data.rotation
  });
};

ElementSetter.prototype.updateOpacity = function (element, data) {
  this.updateAttributeNoUndo(element, 'opacity', data.opacity);
  this.trigger('opacity', element.getAttribute('id'), {
    opacity: data.opacity
  });
};

ElementSetter.prototype.updateLocked = function (element, data) {
  $(element).toggleClass('locked', data.locked);
  this.trigger('locked', element.getAttribute('id'), {
    locked: data.locked
  });
  const selector = this.canvas.selectorManager.requestSelector(element);

  selector.showGrips(!data.locked);
};

ElementSetter.prototype.updateSize = function (element, data) {
  const size = data.size;
  if (!size.width && !size.height) return;

  const svgroot = $('#svgroot').get(0);
  const nBB = element.getBBox();

  const translate = svgroot.createSVGTransform();
  const scale = svgroot.createSVGTransform();
  const rtranslate = svgroot.createSVGTransform();

  const tlist = svgedit.transformlist.getTransformList(element);

  if (!size.width || !size.height) {
    const currentRatio = nBB.width / nBB.height;

    if (!size.width) size.width = size.height * currentRatio;
    if (!size.height) size.height = size.width / currentRatio;
  }

  const offsetX = nBB.x + nBB.width / 2;
  const offsetY = nBB.y + nBB.height / 2;

  translate.setTranslate(offsetX, offsetY);
  scale.setScale(size.width / nBB.width, size.height / nBB.height);
  rtranslate.setTranslate(-offsetX, -offsetY);

  tlist.appendItem(translate);
  tlist.appendItem(scale);
  tlist.appendItem(rtranslate);

  svgedit.recalculate.recalculateDimensions(element, nBB);
};

ElementSetter.prototype.updateAttributeNoUndo = function (element, attributeName, value) {
  this.canvas.changeSelectedAttributeNoUndo(attributeName, value, [element]);
};

ElementSetter.prototype.updateLink = function (element, data) {
  this.canvas.selectOnly([element]);
  const href = data.link.href;
  const page = data.link.page;
  let link = null;

  if (href) {
    link = ((INKIVE.Helpers.isUrlValid(href) || href.indexOf('https://') === 0) ? href : 'https://' + href);
  } else if (page) {
    link = '#' + page;
  }

  link ? this.canvas.makeHyperlink(link) : this.canvas.removeHyperlink();

  this.trigger('update_link', element.getAttribute('id'), data);
};
